// Service
import authenticateService from '@/app/services/main/authenticate/authenticate-service.js';

// Component
const ToastNotification = () => import(/* webpackPrefetch: true, webpackChunkName: "toast-notification" */ '@/app/views/main-view/_shared/_utilities/toast-notification/toast-notification.vue');

// Constants
import { STATUS_CODES } from '@/app/constants/constants.js';

export default {
	name: 'App',
	components: {
		ToastNotification
	},
	computed: {
		showSideBar() {
			return this.$store.getters.getSideBar;
		},
		pinCode() {
			return this.$store.getters.getPinCode;
		}
	},
	created() {
		// this.validatePinCode();
	},
	methods: {
		validatePinCode() {
			const pinDetails = {
				pinCode: this.pinCode
			};
	
			// validate pin code api
			authenticateService.validatePinCode(pinDetails)
				.then(res => {
					if (res.status !== STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.$store.commit('clearLmdcUserDetails');
						this.$store.commit('clearUserToken');
						this.$store.commit('clearUserAuthentication');
						this.$store.commit('clearAuthExpiry');
						this.$router.push('/authenticate');
					}
				});
		}
	}
}